import kanplaA from "./assets/kanpla-a.svg";
import kanplaB from "./assets/kanpla-b.svg";
import kanplaC from "./assets/kanpla-c.svg";
import kanplaD from "./assets/kanpla-d.svg";
import kanplaE from "./assets/kanpla-e.svg";
import { type CO2Rating } from "./nutrition-climate-utils";

/**
 * Climate-grade icons, copied from @kanpla/assets (libs/shared-assets
 * `ratings`). Imported as URLs by Vite and injected inline via react-inlinesvg
 * in <Co2GradeMark>.
 */
export const CO2_GRADE_ICONS: Record<CO2Rating, string> = {
  A: kanplaA,
  B: kanplaB,
  C: kanplaC,
  D: kanplaD,
  E: kanplaE
};
